import {
  REMOVE_ADDON_BY_STRIPE_ID,
  ENABLE_ADDON_PRICE_IF_REQUIRED,
  SET_ADDON_PRICE,
  SET_ERRORS,
  CLEAR_ADDON_CONFIGURATION,
} from "./constants";
import {fetchResaleAddons} from "./methods";
import _ from "lodash";
import Joi from "joi";
import axios from "axios";
import {moduleNamespace as productManagerModuleNamespace} from "../productManager/constants";

/**
 * Validate that all oddons meet the required criteria, mostly defined by the user-created software product prices.
 */
export function validateAddons(state, getters) {
  let allErrors = {};

  _.forEach(getters.addonsByStripeId, (userDefinedAddon, stripeId) => {
    const { minimum, billing_period } = getters.resaleAddonPricesByStripeId[stripeId];

    let label = 'Price';
    switch(billing_period) {
      case 'MONTH':
        label = 'Monthly price';
        break;
      case 'YEAR':
        label = 'Annual price';
        break;
    }

    const tempSchema = Joi.number()
      .label(label)
      .min(minimum)
      .required()
      .messages({
        'number.min': 'This price is below the minimum amount.',
      });

    console.log(userDefinedAddon.price);

    const { error } = tempSchema.validate(userDefinedAddon.price, { abortEarly: false });
    if (error) {
      allErrors[stripeId] = error.details;
    }
  });
  console.log(allErrors);

  if (Object.keys(allErrors).length > 0) {
    return allErrors;
  }
}

export default {
  fetchResaleAddons,
  validateAddons: ({commit, state, getters}) => new Promise((resolve, reject) => {
    const errors = validateAddons(state, getters);
    if (errors) {
      for (const [stripeId, errorDetails] of Object.entries(errors)) {
        commit('SET_ERRORS', {
          errors: errorDetails,
          namespace: `addons.${stripeId}`,
          joi: true
        });
      }
      reject(errors);
      return;
    }
    resolve();
  }),
  enableAddonPriceIfRequired: ({rootState, commit, getters}, payload) => commit(ENABLE_ADDON_PRICE_IF_REQUIRED, {
    supportedCurrencies: rootState[productManagerModuleNamespace].supportedCurrencies,
    softwarePrices: getters.softwareProduct.prices,
    resaleAddonPrice: payload,
  }),
  setAddonPrice: ({commit}, payload) => commit(SET_ADDON_PRICE, payload),
  removeAddonByStripeId: ({commit}, payload) => commit(REMOVE_ADDON_BY_STRIPE_ID, payload),
  setErrors: ({commit}, payload) => commit(SET_ERRORS, payload),
  updateAddons: ({state}) => {
    const {addons} = state;
    return axios.post('/merchant/update-addons', {addons});
  },
  clearAddonConfiguration: ({commit}) => commit(CLEAR_ADDON_CONFIGURATION),
};
